import Box from '@mui/material/Box';
import {
  TechDocsReaderPageContent,
  TechDocsReaderPageHeader,
  TechDocsReaderPageSubheader,
} from '@backstage/plugin-techdocs';
import { docsPageWidth } from '../../theme/tokens';

// Same as the stock TechDocsReaderLayout, but the reader is capped and
// centred so the standalone /docs page matches the entity Docs tab.
// Passed as TechDocsReaderPage children, which already wrap it in a Page.
export const DocsReaderLayout = () => (
  <>
    <TechDocsReaderPageHeader />
    <TechDocsReaderPageSubheader />
    <Box
      sx={{
        gridArea: 'pageContent',
        maxWidth: docsPageWidth,
        minWidth: 0,
        mx: 'auto',
        width: '100%',
      }}
    >
      <TechDocsReaderPageContent />
    </Box>
  </>
);
